import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { MAGENTA } from 'ai-components-ui-library/styles/colors';
import { WarningIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useAIProcessingStatus } from '../ai/useAIProcessingStatus';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { fullWidthCellClassName } from '../utils/fullWidthCellClassName';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { useObjectId } from '../v2/hooks/useObjectId';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';

// We narrow the props down here so we can use this in the formatter as well
// without specifying all the props possible on the input. Props should never be
// added here that are not provided in PropertyInputV2
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputAISkeleton = props => {
  useComponentMountMetric('PropertyInputAISkeleton');
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const objectId = useObjectId();
  const status = useAIProcessingStatus(objectTypeId, property.name, objectId, {
    pollForStatus: false
  });
  if (status === 'completedNoResult') {
    return /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      maxInlineSize: "350px",
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputAISkeleton.noResultTooltipHeading"
      }),
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputAISkeleton.noResultTooltipBody.line1"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputAISkeleton.noResultTooltipBody.line2"
          })
        })]
      }),
      children: /*#__PURE__*/_jsx("span", {
        style: {
          color: MAGENTA[400]
        },
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: WarningIcon,
          padding: "100",
          size: "400"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(AISkeleton, Object.assign({}, getTransferrableProps(props), {
    "data-classname": fullWidthCellClassName,
    height: "0.8em"
  }));
};
export default /*#__PURE__*/memo(PropertyInputAISkeleton);